module.exports = __webpack_public_path__ + "img/cellarsBanner.a0c2762b.jpg";